import * as React from 'react'

import {connect} from 'react-redux'
import * as PrintPreview from '../../core/components/Export/PrintPreview'
import OverlayLoader from '../../core/components/Loading/OverlayLoading'
import SimpleMapPopup from '../../core/components/PopupRenderers/MapPopups/SimpleMapPopup/SimpleMapPopup'
import {
  IDataQueriesDispatcher,
  IGeometryEditsDispatcher,
  IMapDispatcher,
  IPopupDispatcher
} from '../../core/interfaces/dispatchers'
import {IFeatureLayerInfo, IMapPopupProperties} from '../../core/interfaces/models'
import {IFeatureLayerInfos} from '../../core/interfaces/reducers'
import {IMapService} from '../../core/interfaces/services'
import {Feature} from '../../core/models'
import {appDataQueriesDispatcher} from '../../dispatchers/appDataQueriesDispatcher'
import {appExportMapDispatcher} from '../../dispatchers/appExportMapDispatcher'
import {appGeometryEditsDispatcher} from '../../dispatchers/appGeometryEditsDispatcher'
import {appMapDispatcher} from '../../dispatchers/appMapDispatcher'
import {appPopupDispatcher} from '../../dispatchers/appPopupDispatcher'
import {IAppStore, IUserInfo} from '../../interfaces/reducers'
import appConfig from '../../reducers/appConfig'
import EditFeatureDispatcherContainer from '../FeatureViews/EditFeatureDispatcherContainer'
import {ReadOnlyDispatcher} from '../FeatureViews/ReadOnlyDispatcher'
import AppMapContainer from '../Map/AppMapContainer'
import AppMapLayersControl from '../Map/AppMapLayersControl'
import {AppPopupHeader} from '../Map/AppPopupHeader'
import {LabelMovingTool} from './LabelMovingTool'
import {MeasureTool} from './MeasureTool'
import {AreaTool} from './AreaTool'
import {OnMapWidget} from './OnMapWidget'
import {RadiusTool} from './RadiusTool'
import {MapPosition} from './MapPosition'

const PrintPreviewWrapper = connect<PrintPreview.OwnProps, PrintPreview.DispatchProps, PrintPreview.ParentProps>(
  PrintPreview.mapStateToProps,
  {...appExportMapDispatcher, ...appPopupDispatcher}
)(PrintPreview.PrintPreview)

interface DispatchProps extends IMapDispatcher, IGeometryEditsDispatcher, IPopupDispatcher, IDataQueriesDispatcher {}

interface ParentProps {
  onMapServiceReady: (mapService: IMapService) => void
  mapService?: IMapService
}

interface OwnProps {
  infos: IFeatureLayerInfos
  loggedIn: boolean
  mobile: boolean
  userInfo: IUserInfo
  popup: IMapPopupProperties
  printPreview: boolean
  loading: boolean
}

type Props = DispatchProps & OwnProps & ParentProps

interface State {
  isRadiusButtonActive: boolean
  isMesureButtonActive: boolean
  isLabelMovingButtonActive: boolean
  isAreaButtonActive: boolean
}

class MainContent extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props)

    this.state = {
      isRadiusButtonActive: false,
      isMesureButtonActive: false,
      isLabelMovingButtonActive: false,
      isAreaButtonActive: false
    }
  }

  handleIsMesureButtonStateOnClick = () =>
    this.setState(prevState => ({
      isMesureButtonActive: !prevState.isMesureButtonActive,
      isRadiusButtonActive: false,
      isLabelMovingButtonActive: false,
      isAreaButtonActive: false
    }))

  handleIsRadiusButtonStateOnClick = () =>
    this.setState(prevState => ({
      isRadiusButtonActive: !prevState.isRadiusButtonActive,
      isMesureButtonActive: false,
      isLabelMovingButtonActive: false,
      isAreaButtonActive: false
    }))

  handleIsLabelMovingButtonStateOnClick = () =>
    this.setState(prevState => ({
      isLabelMovingButtonActive: !prevState.isLabelMovingButtonActive,
      isMesureButtonActive: false,
      isRadiusButtonActive: false,
      isAreaButtonActive: false
    }))
  handleIsAreaButtonStateOnClick = (isAreaButtonActive: boolean) =>
    this.setState({
      isAreaButtonActive: isAreaButtonActive,
      isMesureButtonActive: false,
      isRadiusButtonActive: false,
      isLabelMovingButtonActive: false
    })

  render() {
    const {isRadiusButtonActive, isMesureButtonActive, isLabelMovingButtonActive, isAreaButtonActive} = this.state

    const isSiteLine =
      this.props.popup.data &&
      this.props.popup.data[this.props.popup.selectedPage] &&
      this.props.popup.data[this.props.popup.selectedPage].id == appConfig.reg.siteLine.id
    const map = (
      <div style={{width: '100%', height: this.props.popup.maximized ? '50%' : '100%', position: 'relative'}}>
        <AppMapContainer
          onMapServiceReady={this.props.onMapServiceReady}
          mapDispatcher={this.props}
          geometryDispatcher={this.props}
          cursorPointer={true}
        />
      </div>
    )
    return (
      <div style={{display: 'flex', position: 'relative', flexDirection: 'column', height: '100%'}}>
        <OverlayLoader show={this.props.loading}></OverlayLoader>
        {appConfig.isPublic && !this.props.loading ? (
          <OnMapWidget
            imgHeight="64px"
            verticalSpeed="0.5s"
            // right={true}
            mapService={this.props.mapService}
            horizontalSpeed="0.2s"
            title={<b style={{fontSize: '18px'}}>Изберете видими слоеве</b>}
            imgSrc="resources/icons/legend-on-map.png"
            content={
              <AppMapLayersControl
                dataQueryDispatcher={this.props}
                hideLegend={true}
                hideBasemaps={false}
                layerListWithLegend={true}
              />
            }
          />
        ) : null}
        {(this.props.printPreview && appConfig.admin) || appConfig.isArchImport || !appConfig.admin ? null : (
          <MeasureTool
            isMesureButtonActive={isMesureButtonActive}
            handleIsMesureButtonStateOnClick={this.handleIsMesureButtonStateOnClick}
            popupDispatcher={this.props}
            left={'80px'}
          ></MeasureTool>
        )}
        {(this.props.printPreview && appConfig.admin) || appConfig.isArchImport || !appConfig.admin ? null : (
          <RadiusTool
            handleIsRadiusButtonStateOnClick={this.handleIsRadiusButtonStateOnClick}
            isRadiusButtonActive={isRadiusButtonActive}
            popupDispatcher={this.props}
            left={'120px'}
          ></RadiusTool>
        )}
        {(this.props.printPreview && appConfig.admin) || appConfig.isArchImport || !appConfig.admin ? null : (
          <LabelMovingTool
            handleIsLabelMovingButtonStateOnClick={this.handleIsLabelMovingButtonStateOnClick}
            popupDispatcher={this.props}
            isLabelMovingButtonActive={isLabelMovingButtonActive}
            left={'160px'}
          ></LabelMovingTool>
        )}
        {(this.props.printPreview && appConfig.admin) || appConfig.isArchImport || !appConfig.admin ? null : (
          <AreaTool
            handleIsAreaButtonStateOnClick={this.handleIsAreaButtonStateOnClick}
            popupDispatcher={this.props}
            isAreaButtonActive={isAreaButtonActive}
            left={'200px'}
          ></AreaTool>
        )}
        {this.props.printPreview ? null : <MapPosition left={'190px'}></MapPosition>}
        <PrintPreviewWrapper>{map}</PrintPreviewWrapper>
        <SimpleMapPopup
          mapService={this.props.mapService}
          mapDispatcher={this.props}
          popupHeight={isSiteLine ? 180 : 380}
          popupWidth={isSiteLine ? 380 : 450}
          tools={[]}
          headerHeight={50}
          centeredPopup={isSiteLine ? false : this.props.mobile}
          detailRenderer={(layerInfo: IFeatureLayerInfo, feature: Feature, popupInfo: IMapPopupProperties) => {
            return isSiteLine ? (
              <EditFeatureDispatcherContainer
                layerId={layerInfo.sourceDescription.id}
                feature={feature}
                editAgain={f => f}
              />
            ) : (
              <ReadOnlyDispatcher layerInfo={layerInfo} feature={feature} mapDispatcher={this.props} />
            )
          }}
          headerRenderer={(layerInfos: IFeatureLayerInfos, popupInfo: IMapPopupProperties) => {
            if (isSiteLine) {
              return <AppPopupHeader hideTable={true} />
            }
            return <AppPopupHeader />
          }}
        />
      </div>
    )
  }
}

const mapStateToProps = (state: IAppStore) => {
  return {
    loggedIn: state.application.loggedIn,
    userInfo: state.userInfo,
    mobile: state.application.mobile,
    popup: state.map.popup,
    printPreview: state.exportMap.previewMode,
    loading: !state.map.sourcesImported,
    infos: state.layerInfos.featureLayerInfos
  }
}

export default connect<OwnProps, DispatchProps, ParentProps>(mapStateToProps, {
  ...appMapDispatcher,
  ...appGeometryEditsDispatcher,
  ...appPopupDispatcher,
  ...appDataQueriesDispatcher
})(MainContent)
